import React, { useEffect, useState } from "react";
import PageTitle from "../Components/PageTitle";
import {
  Box,
  TextField,
  Typography,
  Breadcrumbs,
  Link as MUILink,
} from "@mui/material";
import { Link } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import { Modal } from "antd";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import {
  listContacts,
  deleteContact,
} from "../redux/actions/admin/contactAction";
import Table from "./common/Table";

const Contact = () => {
  const dispatch = useDispatch();
  const { contacts } = useSelector((state) => state.contactList);
  const [search, setSearch] = useState("");
  const [filteredContacts, setFilteredContacts] = useState([]);

  useEffect(() => {
    dispatch(listContacts());
  }, [dispatch]);

  useEffect(() => {
    setFilteredContacts(contacts);
  }, [contacts]);

  // Handle Search
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearch(value);
    const filteredData = contacts.filter(
      (item) =>
        item.name.toLowerCase().includes(value) ||
        item.email.toLowerCase().includes(value)
    );
    setFilteredContacts(filteredData);
  };

  // Delete Contact
  const { confirm } = Modal;
  const handleDeleteContact = (id) => {
    confirm({
      title: "Are you sure you want to delete this Contact?",
      content: "Once deleted, this contact cannot be recovered.",
      okText: "Yes, Delete",
      cancelText: "No, Cancel",
      onOk: async () => {
        await dispatch(deleteContact(id));
        listContacts(); // Reload contacts after deletion
      },
    });
  };

  const columns = [
    {
      field: "rowNumber",
      headerName: "#",
      width: 10,
      sortable: false,
    },
    {
      field: "Actions",
      width: 120,
      renderCell: (value) => (
        <Box>
          <IconButton
            aria-label="delete"
            onClick={() => handleDeleteContact(value?.row?._id)}
          >
            <DeleteIcon sx={{ color: "red" }} />
          </IconButton>
        </Box>
      ),
    },
    {
      field: "name",
      headerName: "Full Name",
      width: 180,
      editable: true,
    },
    {
      field: "email",
      headerName: "E-mail",
      width: 250,
      editable: true,
    },
    {
      field: "phone",
      headerName: "Phone Number",
      width: 200,
      editable: true,
    },
    {
      field: "message",
      headerName: "Message",
      width: 400,
      editable: true,
    },
    {
      field: "createdAt",
      headerName: "Date",
      width: 180,
      renderCell: (params) =>
        moment(params?.row?.createdAt).format("MM/DD/YYYY"),
    },
  ];

  return (
    <div>
      <PageTitle
        title="Manage Contact Submissions - Admin Panel | Shree Mangalam School"
        description="View and manage all contact form submissions received through the website. Respond to inquiries and stay connected with prospective students and parents."
        url="/admin/contact"
        keywords="admin contact form, contact submissions, Shree Manglam contact inquiries, website messages admin, school enquiry management"
      />

      <Typography
        variant="h5"
        align="center"
        gutterBottom
        sx={{
          mb: 3,
          fontFamily: "Poppins, sans-serif",
          color: "#2C3E50",
          letterSpacing: "2.5px",
          lineHeight: 1.8,
        }}
      >
        Contacts
      </Typography>
      <Breadcrumbs
        aria-label="breadcrumb"
        sx={{
          mb: 5,
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
        }}
      >
        <MUILink
          component={Link}
          to="/dashboard"
          sx={{ color: "inherit", textDecoration: "none" }}
        >
          Dashboard
        </MUILink>
        <Typography sx={{ color: "primary.main" }}>Contacts</Typography>
      </Breadcrumbs>

      <TextField
        fullWidth
        variant="outlined"
        placeholder="Search by Name, or Email"
        value={search}
        onChange={handleSearch}
        InputProps={{
          startAdornment: (
            <IconButton>
              <SearchIcon sx={{ color: "#1976d2" }} />
            </IconButton>
          ),
        }}
        sx={{
          mb: 3,
          bgcolor: "white",
          borderRadius: "20px",
          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              border: "none",
            },
            "&:hover fieldset": {
              border: "none",
            },
            "&.Mui-focused fieldset": {
              border: "none",
            },
          },
        }}
      />
      <Box
        style={{
          width: "auto",
          overflowY: "hidden",
          overflowX: "scroll",
        }}
      >
        <Box
          sx={{
            pb: 2,
            display: "flex",
            width: "auto",
            justifyContent: "right",
          }}
        ></Box>
        <Table data={filteredContacts} columns={columns} />
      </Box>
    </div>
  );
};

export default Contact;
